import React from 'react';
import { IMaskInput } from 'react-imask';
import { INTEGER_MAX, INTEGER_MIN } from '@/constant';

interface IntegerMaskProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
  inputRef: (instance: HTMLInputElement | null) => void;
}

const IntegerMask = React.forwardRef<HTMLInputElement, IntegerMaskProps>(
  function IntegerMask(props, ref) {
    const { name, onChange, inputRef, ...other } = props;

    return (
      <IMaskInput
        {...other}
        mask={Number}
        scale={0}
        // `signed` is not one of react-imask's mask props, so it used to end up
        // on the DOM input instead of the mask. A negative `min` is what
        // actually lets the field hold negative numbers.
        min={INTEGER_MIN}
        max={INTEGER_MAX}
        thousandsSeparator=''
        normalizeZeros={false}
        inputRef={(el) => {
          if (ref) {
            if (typeof ref === 'function') {
              ref(el);
            } else {
              (ref as React.MutableRefObject<HTMLInputElement | null>).current = el;
            }
          }
          inputRef(el);
        }}
        onAccept={(value: string) => {
          onChange({ target: { name, value } });
        }}
        overwrite
      />
    );
  },
);

export default IntegerMask;
